export default __webpack_public_path__ + "static/weddings-5c75f0c2b526cfc8c94e688674025d9e.jpg";